var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81824 4.77362V21.1373C6.81824 21.5463 7.09096 21.8191 7.50006 21.8191C7.90915 21.8191 8.18187 21.5463 8.18187 21.1373V4.77362C8.18187 4.36452 7.90915 4.0918 7.50006 4.0918C7.09096 4.0918 6.81824 4.36452 6.81824 4.77362Z",
    fill: "url(#paint0_linear_2146_13219)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50006 25.9082C7.09096 25.9082 6.81824 26.1809 6.81824 26.59C6.81824 26.9991 7.09096 27.2718 7.50006 27.2718H23.8637C24.2728 27.2718 24.5455 26.9991 24.5455 26.59C24.5455 26.1809 24.2728 25.9082 23.8637 25.9082H7.50006Z",
    fill: "url(#paint1_linear_2146_13219)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4545 11.59C20.4545 11.1809 20.1818 10.9082 19.7727 10.9082H12.9545C12.5454 10.9082 12.2727 11.1809 12.2727 11.59C12.2727 11.9991 12.5454 12.2718 12.9545 12.2718H19.7727C20.1818 12.2718 20.4545 11.9991 20.4545 11.59Z",
    fill: "url(#paint2_linear_2146_13219)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3182 13.6367C13.9091 13.6367 13.6364 13.9094 13.6364 14.3185C13.6364 14.7276 13.9091 15.0004 14.3182 15.0004H18.4091C18.8182 15.0004 19.0909 14.7276 19.0909 14.3185C19.0909 13.9094 18.8182 13.6367 18.4091 13.6367H14.3182Z",
    fill: "url(#paint3_linear_2146_13219)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9091 22.5V2.72727C25.9091 1.56818 25.0228 0.681818 23.8637 0.681818H23.1819C23.1819 0.272727 22.9091 0 22.5 0H17.0455C16.6364 0 16.3637 0.272727 16.3637 0.681818V6.13636C16.3637 6.34091 16.5 6.61364 16.7046 6.75C16.9091 6.88636 17.1819 6.88636 17.3864 6.75L19.7728 5.52273L22.2273 6.75C22.4319 6.88636 22.7046 6.81818 22.9091 6.75C23.0455 6.61364 23.1819 6.34091 23.1819 6.13636V4.09091C23.1819 3.68182 22.9091 3.40909 22.5 3.40909C22.0909 3.40909 21.8182 3.68182 21.8182 4.09091V5.04545L20.0455 4.15909C19.8409 4.09091 19.6364 4.09091 19.4319 4.15909L17.7273 5.04545V1.36364H21.8182C21.8182 1.77273 22.0909 2.04545 22.5 2.04545H23.8637C24.2728 2.04545 24.5455 2.31818 24.5455 2.72727V22.5C24.5455 22.9091 24.2728 23.1818 23.8637 23.1818H7.50003C6.75003 23.1818 6.00003 23.4545 5.45458 23.8636V5.45455C5.45458 3.54545 6.95458 2.04545 8.86367 2.04545H14.3182C14.7273 2.04545 15 1.77273 15 1.36364C15 0.954545 14.7273 0.681818 14.3182 0.681818H8.86367C6.20458 0.681818 4.09094 2.79545 4.09094 5.45455V26.5909C4.09094 28.5 5.59094 30 7.50003 30H25.2273C25.6364 30 25.9091 29.7273 25.9091 29.3182C25.9091 28.9091 25.6364 28.6364 25.2273 28.6364H7.50003C6.34094 28.6364 5.45458 27.75 5.45458 26.5909C5.45458 25.4318 6.34094 24.5455 7.50003 24.5455H23.8637C25.0228 24.5455 25.9091 23.6591 25.9091 22.5Z",
    fill: "url(#paint4_linear_2146_13219)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_13219",
    x1: 7.50006,
    y1: 4.0918,
    x2: 7.50006,
    y2: 21.8191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2146_13219",
    x1: 15.6819,
    y1: 25.9082,
    x2: 15.6819,
    y2: 27.2718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2146_13219",
    x1: 16.3636,
    y1: 10.9082,
    x2: 16.3636,
    y2: 12.2718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2146_13219",
    x1: 16.3636,
    y1: 13.6367,
    x2: 16.3636,
    y2: 15.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2146_13219",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.073caa12.svg";
export { ForwardRef as ReactComponent };